export default __webpack_public_path__ + "static/media/areia.58be92fe.JPG";